/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedResultContainer_buyPage = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly item: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_item">;
            } | null;
        } | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedItemTile_itemSearch" | "BuySharedItemTrackingProvider_buyPage">;
    readonly " $refType": "BuySharedResultContainer_buyPage";
};
export type BuySharedResultContainer_buyPage$data = BuySharedResultContainer_buyPage;
export type BuySharedResultContainer_buyPage$key = {
    readonly " $data"?: BuySharedResultContainer_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedResultContainer_buyPage">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedResultContainer_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SharedItemTile_item"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedItemTrackingProvider_buyPage"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'b30b6cc27fd1a50841d7a252cee5eae7';
export default node;
